export const LOCAL_STORAGE_KEYS = {
  DISMISSED_UPDATES: 'dismissedUpdates',
  WIDGET_BUILDER: 'widgetBubble_',
  DRAFT_MESSAGES: 'draftMessages',
  COLOR_SCHEME: 'color_scheme',
  DISMISSED_LABEL_SUGGESTIONS: 'labelSuggestionsDismissed',
  MESSAGE_REPLY_TO: 'messageReplyTo',
  DISMISSED_ANNOUNCEMENTS: 'dismissedAnnouncements',
  KANBAN_SELECTED_PIPELINE: 'kanban_selected_pipeline',
  KANBAN_COLUMN_SORT: 'kanban_column_sort',
  CONTACT_TABLE_COLUMNS: 'contact_table_columns',
  ACTIVITIES_ONBOARDING: 'activitiesOnboardingSeen',
};
